import { render, staticRenderFns } from "./FleetSummary.vue?vue&type=template&id=513bf372&scoped=true&"
import script from "./FleetSummary.vue?vue&type=script&lang=js&"
export * from "./FleetSummary.vue?vue&type=script&lang=js&"
import style0 from "./FleetSummary.vue?vue&type=style&index=0&id=513bf372&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513bf372",
  null
  
)

export default component.exports